"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LatestCatalogues = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _Catalogues = require("./Catalogues");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LatestCatalogues = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { data, loading } = (0, _contexts.useCataloguesLandingPageContext)();
    const showNextCatalogue = loading || !data || !!data.nextCatalogue;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.LATEST_CATALOGUES),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.MobileLatestCataloguesDescription, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                showNextCatalogue: showNextCatalogue,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Catalogues.Catalogues, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DesktopLatestCataloguesDescription, {})
                ]
            })
        ]
    });
};
exports.LatestCatalogues = LatestCatalogues;
